import { useState } from 'react'
import { Icon } from '../ui/Icons'
import IosInstallModal from './IosInstallModal'

const variants = {
  // Ítem del sidebar azul del panel.
  sidebar: 'flex min-h-11 w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-white/80 transition hover:bg-white/10 hover:text-white',
  // Botón secundario sobre fondo claro (logins, pantalla inicial).
  secondary: 'flex min-h-12 w-full items-center justify-center gap-2 rounded-xl border border-border bg-surface px-4 py-3 font-semibold text-primary transition hover:border-secondary hover:bg-secondary/5',
}

export default function InstallAppButton({ installState, variant = 'sidebar', label = 'Instalar aplicación' }) {
  const [showIosHelp, setShowIosHelp] = useState(false)
  const { canNativeInstall, install, isIos, shouldShow } = installState

  if (!shouldShow) return null

  async function handleInstall() {
    // iOS (cualquier navegador) no tiene instalación nativa: se muestran instrucciones.
    if (isIos) {
      setShowIosHelp(true)
      return
    }
    if (canNativeInstall) await install()
  }

  return (
    <>
      <button type="button" onClick={handleInstall} className={variants[variant]}>
        <Icon name="download" />{label}
      </button>
      {showIosHelp && <IosInstallModal onClose={() => setShowIosHelp(false)} />}
    </>
  )
}
